// @ts-nocheck
import PropTypes from "prop-types";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {BaseAlert, BaseSpinner} from "@/components";
import useGetUserWallet from "../../../../hooks/wallet/useGetUserWallet";
import useCurrencyStore from "../../../../store/useCurrency.store";

const WithdrawalAmount = ({setWithdrawalAmount, setIsNextDisabled}) => {
  const {isLoading, balance, getAccountByCurrency} = useGetUserWallet();
  const selectedCurrency = useCurrencyStore(state => state.selectedCurrency);
  const [error, setError] = useState("");

  const {t} = useTranslation();

  const isMobile = window.innerWidth <= 768;
  const FontSize = "16px";

  // Get the balance for the currently selected currency
  const currentCurrencyAccount = selectedCurrency ? getAccountByCurrency(selectedCurrency.id) : balance;

  useEffect(() => {
    setIsNextDisabled?.(true);
  }, [setIsNextDisabled]);

  const handleChange = e => {
    const value = e.target.value;
    // Only allow numbers and decimals
    const numberRegex = /^\d*\.?\d*$/;
    if (value.trim() === "") {
      setError("");
      setIsNextDisabled?.(true);
      return;
    }
    if (!numberRegex.test(value)) {
      setError(t("transferStepsAmountError"));
      setIsNextDisabled?.(true);
      return;
    }
    const amount = e.target.value;
    if (!Number.parseFloat(amount)) {
      setError(t("withdrawalSteps_2_AmountError"));
      setIsNextDisabled?.(true);
      return;
    }
    if (!currentCurrencyAccount) {
      setError(t("widthdrawalSteps_2_Error2"));
      setIsNextDisabled?.(true);
      return;
    }

    // Check if amount exceeds the current currency balance
    if (Number.parseFloat(amount) > currentCurrencyAccount.balance) {
      setError(
        `${t("widthdrawalSteps_2_Error2")} - ${t("currencyName")}: ${t(`currency${selectedCurrency?.id || "VES"}`)}`
      );
      setIsNextDisabled?.(true);
      return;
    }

    // Currency-specific minimum amount validation
    const currencyId = selectedCurrency?.id || "VES";
    let minimumAmount = 200; // Default VES minimum
    if (currencyId === "USD") {
      minimumAmount = 5; // $5 minimum for USD
    } else if (currencyId === "USDT") {
      minimumAmount = 5; // 5 USDT minimum for USDT
    }

    if (Number.parseFloat(amount) < minimumAmount) {
      const currencySymbol = t(`currencySymbol${currencyId}`);
      setError(`${t("widthdrawalSteps_2_Error3").replace("200 Bs", `${minimumAmount} ${currencySymbol}`)}`);
      setIsNextDisabled?.(true);
      return;
    }

    // Currency-specific maximum amount validation
    let maximumAmount = 50000; // Default VES maximum
    if (currencyId === "USD") {
      maximumAmount = 1000; // $1000 maximum for USD
    } else if (currencyId === "USDT") {
      maximumAmount = 1000; // 1000 USDT maximum for USDT
    }

    if (Number.parseFloat(amount) > maximumAmount) {
      const currencySymbol = t(`currencySymbol${currencyId}`);
      setError(
        `${t("widthdrawalSteps_2_Error4").replace("8.000 Bs", `${maximumAmount.toLocaleString()} ${currencySymbol}`)}`
      );
      setIsNextDisabled?.(true);
      return;
    }

    // Update the state with the validated amount
    setWithdrawalAmount(Number.parseFloat(amount));
    setError("");
    setIsNextDisabled?.(false);
  };

  return (
    <div>
      <h4 style={{fontWeight: 700, fontSize: isMobile ? FontSize : undefined}}>{t("withdrawalSteps_2_Amount")}</h4>
      {isLoading && <BaseSpinner size="lg" />}
      {!isLoading && error && (
        <BaseAlert
          variant="danger"
          description={error}
        />
      )}
      {!isLoading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            marginTop: "var(--space-5-5)",
          }}
        >
          <div
            style={{
              position: "relative",
              width: 317,
              height: 49,
              marginBottom: isMobile ? 24 : 100,
            }}
          >
            <input
              type="text"
              inputMode="decimal"
              pattern="[0-9]*"
              style={{
                width: "100%",
                height: "100%",
                borderRadius: "var(--radius-xl)",
                opacity: 1,
                borderWidth: 1,
                paddingTop: "var(--space-4)",
                paddingRight: 60,
                paddingBottom: "var(--space-4)",
                paddingLeft: 23,
                background: "#FEF8AD",
                border: "1px solid var(--color-gray-4-alt)",
                fontWeight: 500,
                fontSize: "var(--font-h2)",
                fontFamily: "inherit",
                boxSizing: "border-box",
                outline: "none",
                color: "#000",
              }}
              placeholder={t("transferStepsTransferAmountInput")}
              onChange={handleChange}
            />
            <span
              style={{
                position: "absolute",
                right: 23,
                top: "50%",
                transform: "translateY(-50%)",
                fontWeight: 500,
                fontSize: "var(--font-h2)",
                color: "var(--color-gray-4-alt)",
                pointerEvents: "none",
              }}
            >
              {selectedCurrency ? t(`currencySymbol${selectedCurrency.id}`) : "Bs."}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

WithdrawalAmount.propTypes = {
  setWithdrawalAmount: PropTypes.func.isRequired,
  setIsNextDisabled: PropTypes.func,
};

export default WithdrawalAmount;
